<template lang="pug">
.b-sign-in__container.login-mobile-id-form
  login-types-links
  .b-sign-in__form
    form.f-default.f-sign-in(@submit.prevent = 'onSubmit')
      .f-default__row
        .f-default__label(:class = '{ "_error": error }')
          span.f-default__label-text {{ $t('phone') }}
          .f-default__label-wrapper
            fi-phone-input(
              v-model.trim = 'phone'
              :placeholder = '$t("phonePh")'
              :disabled    = 'loading'
              input-class  = 'f-default__field'
            )
            .f-default__error(v-if = 'error') {{ error }}
      .f-default__row
        label.f-default__label(:class = '{ "_error": error }')
          span.f-default__label-text {{ $t('idCode') }}
          .f-default__label-wrapper
            input.f-default__field(
              v-model.trim   = 'idCode'
              type           = 'text'
              :placeholder   = '$t("idCodePh")'
              :disabled      = 'loading'
              @input.prepend = '$emit("input")'
            )
            .f-default__error(v-if = 'error') {{ error }}
      .f-default__row(v-if = 'code')
        label.f-default__label
          span.f-default__label-text {{ $t('message1', { code }) }}
          span.f-default__label-text {{ $t('message2') }}
      .f-sign-in__reset
      .f-default__action.f-sign-in__action
        button.btn._sign._wide(
          type      = 'submit'
          :disabled = '!phone || !idCode ||loading'
        ) {{ $t('signIn') }}
          fi-spinner.inverse.ml-10(v-if = 'loading')
</template>

<script>
import FiSpinner from "@/components/FiSpinner";
import LoginTypesLinks from "./LoginTypesLinks";
import FiPhoneInput from "@/components/FiPhoneInput";

export default {
  name: "login-mobile-id-form",

  components: {
    FiPhoneInput,
    FiSpinner,
    LoginTypesLinks
  },

  props: {
    error: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    code: {
      type: String,
      default: null
    }
  },

  i18nOptions: {},

  data() {
    return {
      phone: undefined,
      idCode: undefined
    };
  },

  methods: {
    onSubmit() {
      this.$emit("submit", { ...this.$data });
    }
  }
};
</script>

<i18n>
en:
  phone:    "Phone"
  phonePh:  "your phone number"
  idCode:   "ID code"
  idCodePh: "your ID code"
  signIn:   "Sign in"
  message1: "Your control code is: {{code}}"
  message2: "Message sent to your telephone. Check the code!"
et:
  phone:    "Telefon"
  phonePh:  "teie telefoni number"
  idCode:   "ID-kood"
  idCodePh: "teie ID kood"
  signIn:   "Logi sisse"
  message1: "Teie kontrollkood on: {{code}}"
  message2: "Teade on saadetud Teie telefonile. Kontrolli koodi!"
ru:
  phone:    "Телефон"
  phonePh:  "Ваш номер телефона"
  idCode:   "ID код"
  idCodePh: "ваш ID код"
  signIn:   "Войти"
  message1: "Ваш контрольный код: {{code}}"
  message2: "Сообщение отправлено на Ваш телефон. Проверьте код!"
lt:
  phone:    "Telefonas"
  phonePh:  "Jūsų telefono numeris"
  idCode:   "Asmens kodas"
  idCodePh: "Jūsų asmens kodas"
  signIn:   "Prisijungti"
  message1: "Jūsų saugos kodas: {{code}}"
  message2: "Žinutė išsiųsta į Jūsų telefoną, patikrinkite kodą."
sv:
  phone:    "Telefonnummer"
  phonePh:  "Ditt telefonnummer"
  idCode:   "ID kod"
  idCodePh: "Din ID kod"
  signIn:   "Logga in"
  message1: "Din kontroll kod är: {{code}}"
  message2: "Meddelande är skickat till din telefon. Kolla koden!"
lv:
  phone:    "Tālrunis"
  phonePh:  "Jūsu tālruņa numurs"
  idCode:   "Personas kods"
  idCodePh: "Jūsu personas kods"
  signIn:   "Pieslēgties"
  message1: "Jūsu kontroles kods ir: {{code}}"
  message2: "Ziņa nosūtīta uz jūsu tālruni. Pārbaudiet kodu!"
</i18n>
